import { useFlags } from 'launchdarkly-react-client-sdk';
import { FLAGS } from 'shared/utils/launchdarkly/flags';
export var useFlagWithDefaults = function (flag, testDefaultValue) {
    var selectedDefaultValue = typeof testDefaultValue !== 'undefined' && process.env.NODE_ENV === 'test'
        ? testDefaultValue
        : FLAGS[flag].default;
    var useFlagsResult = useFlags();
    var fetchedValue = useFlagsResult && FLAGS[flag].name in useFlagsResult
        ? useFlagsResult[FLAGS[flag].name]
        : selectedDefaultValue;
    return fetchedValue;
};
